import Form, { Field } from 'mobx-react-form';
import { passwordValid } from 'utils/passwordRules';
import validator from 'validator';

export const isRequired = ({ field }: { field: Field }) => {
  const isValid = !!field.value && !validator.isEmpty(field.value?.title || field.value);
  return [isValid, `The ${field.label} field is required.`];
};

export const isEmail = ({ field }: { field: Field }) => {
  const isValid = field.value.length === 0 || validator.isEmail(field.value);
  return [isValid, `The ${field.label} field must be an email address.`];
};

/**
 * If two fields need to match, put the "isSame" rule on the second one,
 * and put this on the first one, so it re-validates the second one when you change it.
 */
export const triggerValidate =
  (triggerFieldName: string) =>
  ({ field, form }: { field: Field; form: Form }) => {
    const triggerField = form.$(triggerFieldName);
    if (triggerField.touched) {
      triggerField.validate({ showErrors: true });
    }
    return [true, ''];
  };

export const isSame =
  (asField: string) =>
  ({ field, form }: { field: Field; form: Form }) => {
    const isValid = field.value + '' === form.$(asField).value + '';
    return [isValid, `The ${field.label} and ${form.$(asField).label} fields must match.`];
  };

export const isPasswordValid = ({ field }: { field: Field }) => {
  const isValid = field.value.length === 0 || passwordValid(field.value);
  return [isValid, `The ${field.label} field must meet the specified rules.`];
};

export const passwordStrength =
  (min: number, minLabel: string) =>
  ({ field }: { field: Field }) => {
    const isValid = field.value.length === 0 || field.extra?.passwordStrength >= min;
    return [isValid, `The ${field.label} strength must be at least "${minLabel}".`];
  };

/**
 * Call from onChangeScore in PasswordStrengthMeter.
 * Stores the strength in the "extra" property of the field, for use by the passwordStrength validator.
 */
export const setPasswordStrength = (field: Field, score: number) => {
  field.set('extra', { passwordStrength: score });
  field.validate({ showErrors: true });
};
